import React, { useState } from "react";
import {
Box,
Card,
Typography,
Button,
TextField,
Alert,
CircularProgress
} from "@mui/material";

import { validateEmail } from "../utils/validate";
import { Colors } from "../utils/colors";
import { useNavigate } from "react-router-dom";
import { API } from "../constant/apiConstant";

const ForgotPassword = () => {

const navigate = useNavigate()

const [email,setEmail] = useState("")
const [loading,setLoading] = useState(false)
const [alert,setAlert] = useState({
show:false,
type:"info",
message:""
})

const showAlert=(type,message,time=5000)=>{

setAlert({
show:true,
type,
message
})

setTimeout(()=>{
setAlert(prev=>({...prev,show:false}))
},time)

}




const sendResetOTP = async () => {

setLoading(true)

try{

const res = await fetch(`${API.BASE_URL}/api/otp/forgot-password/send-otp`,{
method:"POST",
headers:{
"Content-Type":"application/json"
},
body:JSON.stringify({email})
})

const data = await res.json()

if(!data.status){

showAlert("error",data.message || "Unable to send reset OTP")

}else{

showAlert("success","If this is an account email, password reset instructions have been sent.")

setTimeout(()=>{
navigate("/verify-reset-otp",{state:{email}})
},2000)

}

}catch(error){

showAlert("error","Unable to connect to server")

}

setLoading(false)

}


return(

<Box
sx={{
minHeight:"50vh",
p:3,
display:"flex",
justifyContent:"center",
alignItems:"center"
}}
>

<Card sx={{p:4,borderRadius:1,width:"100%",maxWidth:500}}>

<Typography
variant="h5"
sx={{color:Colors.accent}}
fontWeight={700}
>
Forgot Password
</Typography>


{alert.show && (
<Alert severity={alert.type} sx={{mt:2}}>
{alert.message}
</Alert>
)}

<TextField
label="Email Address"
fullWidth
sx={inputStyle}
value={email}
error={!!email && !validateEmail(email)}
helperText={
email && !validateEmail(email)
? "Invalid email format"
: ""
}
onChange={(e)=>setEmail(e.target.value)}
/>


<Button
fullWidth
variant="contained"
sx={{mt:3,backgroundColor:Colors.secondary,color:"white"}}
disabled={!validateEmail(email)||loading}
onClick={sendResetOTP}
>

{loading
? <CircularProgress size={24} sx={{color:"white"}}/>
: "Send Reset OTP"
}

</Button>


<Typography
sx={{
mt:2,
textAlign:"center",
color:Colors.muted,
fontSize:14
}}
>

Remember your password?{" "}
<span
style={{
color:Colors.accent,
cursor:"pointer",
textDecoration:"underline",
fontWeight:600
}}
onClick={()=>navigate("/login")}
>
Login
</span>

</Typography>

</Card>

</Box>

)

}


const inputStyle={
mt:2,
"& .MuiOutlinedInput-root":{
"& fieldset":{borderColor:Colors.accent},
"&:hover fieldset":{borderColor:Colors.accent},
"&.Mui-focused fieldset":{borderColor:Colors.accent}
},
"& .MuiInputLabel-root":{
color:Colors.accent
},
"& .MuiInputLabel-root.Mui-focused":{
color:Colors.accent
},
input:{
color:"whitesmoke"
}
}

export default ForgotPassword